module.exports = __webpack_public_path__ + "media/images/color_admin_v3/product/product-2-db39785cf2e2f67ec1bd33b783f1ba17.png";